import { Tooltip } from '@mui/material';
import { ReactElement } from 'react';

export default function NotAllowedTooltip({
  children
}: {
  children: ReactElement;
}) {
  return (
    <Tooltip
      arrow
      placement="left"
      title="Your role doesn't have the authority to access this feature"
    >
      {children}
    </Tooltip>
  );
}
